<!-- <div class="resumeUploadPopUp" style="padding: 38px;
width: 500px;">
    <h3 style="text-align: center; color: green">Thank you for your submission.</h3>
    <p style="text-align: center; color: #000">We're reviewing your application and will email you the coding test schedule and details soon.</p>
  </div> -->

  <div class="resume-upload-popup">
    <div class="content">
      <div class="mt-4 mx-auto text-center" style="max-width:600px">
        <svg width="96px" height="96px" viewBox="0 0 96 96" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="round-check">
            <circle id="Oval" fill="#D3FFD9" cx="48" cy="48" r="48"></circle>
            <circle id="Oval-Copy" fill="#87FF96" cx="48" cy="48" r="36"></circle>
            <polyline id="Line" stroke="#04B800" stroke-width="4" stroke-linecap="round" points="34.188562 49.6867496 44 59.3734993 63.1968462 40.3594229"></polyline>
          </g>
          </g>
        </svg>
        <div class="my-3">
          <h1> {{data.title}}</h1>
          <p>{{data.message}}</p>
        </div>
        </div>
    </div>
</div>